import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  CircularProgress,
  useMediaQuery,
  IconButton,
  Alert,
  AlertTitle,
  Snackbar,
  Alert as SnackbarAlert,
  Button,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import DataTable from "../Candidates/DataTable";
import { ControlledBoard } from "../Candidates/board";
import { useTranslation } from "react-i18next";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ShareIcon from "@mui/icons-material/Share";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import axios from "axios";
// Add imports for the edit dialog components
import EditPostDetailsDialog from "./Dialogs/EditPostDetailsDialog";
import EditWorkingDetailsDialog from "./Dialogs/EditWorkingDetailsDialog";
import ImportResumes from "./imported/ImportResumes";
import QRCodeDialog from "./QRCodeDialog";
import colors from "colors/color";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import GmailAuth from "views/ScrapedPosts/GmailAuth";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import styled from "styled-components";
import { COLORS } from "colors/color";

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: COLORS.Button_OnHold,
  color: COLORS.signIn,
  borderColor: COLORS.signIn,
  border: `1px solid ${COLORS.signIn}`,
  "&:hover": {
    backgroundColor: COLORS.signIn,
    color: "white",
  },
  padding: "10px 20px",
  marginLeft: "2%",
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: "bold",
  fontSize: "10px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
  transition: "all 0.3s ease",
}));
const NewPostDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [displayMode, setDisplayMode] = useState("table"); // "table" or "board"
  const [steps, setSteps] = useState([]);
  const [applications, setApplications] = useState([]);
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const apiUrl = process.env.REACT_APP_API_URL;

  // Add state variables for the edit dialogs
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editWorkingDialogOpen, setEditWorkingDialogOpen] = useState(false);
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  const [showQRCodeDialog, setShowQRCodeDialog] = useState(false);
  const [qrCodeUrl, setQRCodeUrl] = useState("");
  const [postTitle, setPostTitle] = useState("");
  const [postDescription, setPostDescription] = useState("");
  const [postRequirement, setPostRequirement] = useState([]);
  const [postDeadline, setPostDeadline] = useState("");
  const [offerType, setOfferType] = useState("job");
  const [errors, setErrors] = useState({});
  const [dateError, setDateError] = useState("");
  const [reference, setReference] = useState("");
  const [accountType, setAccountType] = useState("");
  const [recruiterEmail, setRecruiterEmail] = useState("");
  const [workingMode, setWorkingMode] = useState("Remote");
  const [locationValue, setLocationValue] = useState("");
  const [numPeople, setNumPeople] = useState("");
  const [salary, setSalary] = useState("");
  const [currency, setCurrency] = useState("MAD");
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedScr, setIsCheckedScr] = useState(false);
  const [experience, setExperience] = useState("");
  const [diploma, setDiploma] = useState("");
  const [otherDiploma, setOtherDiploma] = useState("");
  const [fieldOfStudy, setFieldOfStudy] = useState("");
  const [otherFieldOfStudy, setOtherFieldOfStudy] = useState("");
  const [postImage, setPostImage] = useState("");
  const [state, statechange] = useState(false);
  const [isProcessingOutlook, setIsProcessingOutlook] = useState(false);
  const intervalIdRef = useRef(null);
  const [isScrappingLaunched, setIsScrappingLaunched] = useState(false);
  const [finishing, setfinishing] = useState(false);
  const [scrapingStatus, setScrapingStatus] = useState({
    status: null,
    message: "",
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [applicationsImported, setApplicationsImported] = useState([]);
  const [code, setCode] = useState("");
  const [filterOptions, setFilterOptions] = useState({ quiz: false });
  const [isProcessing, setIsProcessing] = useState(false);
  const [showGmailAuth, setShowGmailAuth] = useState(false);
  const [copied, setCopied] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // Check if this is a scraped post based on the URL
  const isScrapedPost = location.pathname.includes("/scraped/");

  // Decode the ID if it's base64 encoded
  const decodedId = atob(id);

  // Initialize edit states when post data is loaded
  useEffect(() => {
    if (post && post.id) {
      setPostTitle(post.title || "");
      setPostDescription(post.description || "");
      setPostRequirement(post.requirements || []);
      setPostDeadline(post.deadline || "");
      setOfferType(post.offerType === "i" ? "internship" : "job");
      setReference(post.reference || "");
      setAccountType(post.accountType || "");
      setRecruiterEmail(post.recruiter_email || "");
      setWorkingMode(post.mode || "Remote");
      setLocationValue(post.localisation || "");
      setNumPeople(post.age_experience || "");
      setSalary(post.salary || "");
      setCurrency(post.currency || "MAD");
      setExperience(post.experiences || "");
      setDiploma(post.highest_diploma || "");
      setFieldOfStudy(post.field_of_study || "");
      setPostImage(post.image || "");
    }
  }, [post]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch post data
        let postEndpoint = `${apiUrl}posts/${decodedId}/find`;
        if (isScrapedPost) {
          // If it's a scraped post, you might need a different endpoint
          // For now, we'll use the same endpoint but you can modify this
          postEndpoint = `${apiUrl}posts/${decodedId}/find`;
        }

        const postResponse = await axios.get(postEndpoint);
        setPost(postResponse.data);

        // Fetch applications for this post
        let applicationsEndpoint = `${apiUrl}candidates/applications/by-post/${decodedId}/`;
        if (isScrapedPost) {
          // For scraped posts, you might want to use a different endpoint
          applicationsEndpoint = `${apiUrl}authentication/candidates-scraped-for-post/${decodedId}/`;
        }

        const applicationsResponse = await axios.get(applicationsEndpoint, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        });
        setApplications(applicationsResponse.data);

        // Fetch steps
        // const userId = getUserIdFromAccessToken();
        console.log("post id is: ", decodedId);
        if (decodedId) {
          const stepsResponse = await fetch(
            `${apiUrl}recruiters/steps/?post=${decodedId}`,
            {
              method: "GET",
              headers: {
                "Content-type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("accessToken"),
              },
            }
          );

          if (stepsResponse.ok) {
            const stepsData = await stepsResponse.json();
            if (Array.isArray(stepsData)) {
              const stepTitles = stepsData.map((step) => step.step);
              setSteps(stepTitles);
            }
          }
        }

        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load post details");
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id, apiUrl, isScrapedPost]);

  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return null;

    try {
      const base64Url = accessToken.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      const decodedToken = JSON.parse(jsonPayload);
      return decodedToken.user_id;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }

  // Function to update application step
  const updateApplicationStep = async (
    applicationId,
    newStep,
    status,
    description
  ) => {
    try {
      const url =
        status !== "Application-Imported" &&
          status !== "Scraping-Email" &&
          status !== "Application Spontane"
          ? `${apiUrl}authentication/applications/${applicationId}/update-step/`
          : `${apiUrl}authentication/applicationsscraped/${applicationId}/update-step/`;

      console.log(
        "Updating application step: ",
        applicationId,
        newStep,
        " status: ",
        status,
        " Link: ",
        url
      );

      // In a real implementation, you would make the actual API call here
      const response = await axios.patch(
        url,
        { step: newStep },
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.status === 200) {
        // Update local applications state
        setApplications((prev) =>
          prev.map((app) =>
            app.id === applicationId ? { ...app, step: newStep } : app
          )
        );
      }
    } catch (error) {
      console.error("Error updating application step:", error);
    }
  };

  // Function to refresh applications data
  const refreshApplications = async () => {
    try {
      let quizParam = filterOptions.quiz ? "?quiz=true" : "";

      if (filterOptions.quiz_answers && Object.keys(filterOptions.quiz_answers).length > 0) {
        const prefix = quizParam ? "&" : "?";
        quizParam += `${prefix}quiz_answers=${encodeURIComponent(JSON.stringify(filterOptions.quiz_answers))}`;
      }

      if (filterOptions.step) {
        const prefix = quizParam ? "&" : "?";
        quizParam += `${prefix}step=${encodeURIComponent(filterOptions.step)}`;
      }

      let applicationsEndpoint = `${apiUrl}candidates/applications/by-post/${decodedId}/${quizParam}`;
      if (isScrapedPost) {
        applicationsEndpoint = `${apiUrl}authentication/candidates-scraped-for-post/${decodedId}/${quizParam}`;
      }

      const applicationsResponse = await axios.get(applicationsEndpoint, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });
      setApplications(applicationsResponse.data);
    } catch (error) {
      console.error("Error refreshing applications:", error);
    }
  };

  useEffect(() => {
    if (id) {
      refreshApplications();
    }
  }, [id, filterOptions.quiz, JSON.stringify(filterOptions.quiz_answers || {}), filterOptions.step]);

  // Function to delete steps
  const deleteSteps = async (stepTitle) => {
    if (!stepTitle) return;

    const userId = getUserIdFromAccessToken();
    if (!userId) return;

    try {
      // Find the step to delete
      // In a real implementation, you would have the full step data
      console.log("Deleting step:", stepTitle);

      // Update steps after deletion
      setSteps((prevSteps) => prevSteps.filter((step) => step !== stepTitle));
    } catch (error) {
      console.error("Error deleting step:", error);
    }
  };

  // Function to create steps
  const createStep = (stepName) => {
    const userId = getUserIdFromAccessToken();
    if (!userId) return;

    console.log("Creating step:", stepName);

    // Update steps only if the step doesn't already exist
    setSteps((prevSteps) => {
      if (!prevSteps.includes(stepName)) {
        return [...prevSteps, stepName];
      }
      return prevSteps;
    });
  };

  const handleToggleView = (event) => {
    setDisplayMode(event.target.checked ? "board" : "table");
  };

  const handleViewPost = () => {
    // Navigate to view job page (same as visualizePost in PostDetails)
    const encodedId = btoa(post.id);
    navigate(`/viewjob/${encodedId}`);
  };

  // Update the edit handler to open the dialog
  const handleEditPost = () => {
    setEditDialogOpen(true);
  };

  // Add handler for the date change
  const handleDateChange = (newDate) => {
    setPostDeadline(newDate);
    setDateError("");
  };

  // Add handler for the next button in the first dialog
  const handleNext = () => {
    // Validate form
    const newErrors = {};

    if (!postTitle.trim()) {
      newErrors.postTitle = t("errors.requiredField");
    }

    if (!postDescription.trim()) {
      newErrors.postDescription = t("errors.requiredField");
    }

    if (!offerType) {
      newErrors.offerType = t("errors.requiredField");
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Move to second dialog
    setEditDialogOpen(false);
    setEditWorkingDialogOpen(true);
  };

  // Add handler for image upload
  const handleImageUpload = (image) => {
    setPostImage(image);
    setErrors((prev) => ({ ...prev, postImage: "" }));
  };

  // Add handler for salary change
  const handleSalaryChange = (value) => {
    setSalary(value);
  };

  // Add handler for checkbox changes
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleCheckboxChangeScr = (event) => {
    setIsCheckedScr(event.target.checked);
  };

  // Add handler for saving the post
  const handleSave = async (secondDialogData) => {
    try {
      // Format the data to match API expectations
      const completeUpdateData = {
        postId: post.id,
        title: postTitle,
        description: postDescription,
        experiences: postDescription, // Simplified - in real implementation you might want to strip HTML
        requirements: postRequirement,
        deadline: postDeadline,
        reference: reference || null,
        mode: secondDialogData.mode,
        localisation: secondDialogData.localisation,
        age_experience: secondDialogData.age_experience || null,
        salary: secondDialogData.salary !== "" ? secondDialogData.salary : null,
        offerType: offerType === "internship" ? "i" : "j",
        image: secondDialogData.image,
        field_of_study: secondDialogData.field_of_study,
        highest_diploma: secondDialogData.highest_diploma,
        currency: secondDialogData.currency || currency,
      };

      console.log("Sending update with data:", completeUpdateData);

      // Call API to update post
      const response = await axios.put(
        `${apiUrl}posts/${post.id}/update/`,
        completeUpdateData,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.status === 200) {
        // Update local post state
        setPost((prev) => ({
          ...prev,
          ...completeUpdateData,
          offerType: offerType === "internship" ? "i" : "j",
        }));

        // Close dialog
        setEditWorkingDialogOpen(false);

        // Show success message
        setSnackbar({
          open: true,
          message: t("operation_success"),
          severity: "success",
        });
        console.log("Post updated successfully");
      }
    } catch (error) {
      console.error("Error updating post:", error);
      setSnackbar({
        open: true,
        message: t("errors.loadFailed"),
        severity: "error",
      });
    }
  };

  // Share functionality - copy job link to clipboard and show QR code dialog (same as copyViewJobUrl in PostDetails)
  const handleSharePost = () => {
    const encodedId = btoa(post.id); // Encode the ID
    const url = `${window.location.origin}/viewjob/${encodedId}`;

    // Copy to clipboard
    navigator.clipboard.writeText(url).then(() => {
      // Set the URL for QR code and open dialog
      setQRCodeUrl(url);
      setShowQRCodeDialog(true);
    });
  };

  const handleCloseQRCodeDialog = () => {
    setShowQRCodeDialog(false);
  };

  // Update import resumes to open the dialog
  const handleImportResumes = () => {
    setImportDialogOpen(true);
  };

  const handleImportSuccess = () => {
    // Refresh applications or show success message
    setSnackbar({
      open: true,
      message: t("operation_success"),
      severity: "success",
    });
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const Scrapping = async () => {
    try {
      // Start the scraping process
      setIsProcessingOutlook(true);
      console.log("here is the post id: ", post.id);
      const response = await fetch(
        `${apiUrl}ai/start_scraping_post/${post.id
        }/?source_call=post&sujet=${encodeURIComponent("subject")}`,
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.status === 401) {
        console.log("Unauthorized. Redirecting to login page...");
        navigate("/login");
        return;
      }

      const result = await response.json();
      console.log("Scraping task initiated: ", result);

      // Handle the new state format while maintaining backward compatibility
      if (result.state === "in_progress" || result.state === true) {
        // Clear any existing interval before starting a new one
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
          intervalIdRef.current = null;
        }
        pollScrapingStatus(post.id);
      } else {
        console.error("Failed to start scraping: ", result.message);
      }
    } catch (error) {
      console.error("Error initiating scraping:", error);
    }
  };

  const pollScrapingStatus = async (id) => {
    try {
      console.log("before the 30s");
      await new Promise((resolve) => setTimeout(resolve, 30000));
      console.log("after the 30s");

      // Add a variable to track the start time
      const startTime = Date.now();
      const timeoutDuration = 3 * 60 * 1000; // 3 minutes in milliseconds

      intervalIdRef.current = setInterval(async () => {
        try {
          // Check if we've exceeded the timeout duration
          if (Date.now() - startTime > timeoutDuration) {
            console.log(
              "Polling timeout reached (3 minutes). Stopping API calls."
            );
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
            setIsScrappingLaunched(false);
            statechange(false);
            setfinishing(true);
            setIsProcessingOutlook(false);
            setScrapingStatus({
              status: "timeout",
              message: "Operation timed out after 3 minutes",
            });
            return;
          }

          const response = await fetch(
            `${apiUrl}ai/get_scraping_status/${post.id}/`,
            {
              headers: {
                "Content-type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("accessToken"),
              },
            }
          );

          const result = await response.json();
          console.log("Polling result: ", result);

          // Update the scraping status based on the response
          setScrapingStatus({
            status: result.state,
            message: result.message,
          });

          if (result.state !== "in_progress" && result.state !== "pending") {
            if (intervalIdRef.current) {
              clearInterval(intervalIdRef.current);
              intervalIdRef.current = null;
            }

            setIsScrappingLaunched(false);
            statechange(false);
            setfinishing(true);

            if (result.state === "success" || result.state === true) {
              setOpenSnackbar(true);
              setIsProcessingOutlook(false);
              Load_applications_imported();
            }
          }
        } catch (error) {
          console.error("Error in polling interval:", error);
          setScrapingStatus({
            status: "failed",
            message: "Error occurred while scraping",
          });
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
          }
        }
      }, 5000);
    } catch (error) {
      console.error("Error polling scraping status:", error);
    }
  };
  async function Load_applications_imported() {
    try {
      const response = await fetch(
        `${apiUrl}authentication/candidates-scraped-for-post/${post.id}/`,
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );
      if (response.status === 401) {
        return;
      }
      const json = await response.json();
      setApplicationsImported(json);
      console.log("applications imported : ", json);
    } catch (error) {
      console.error("Error loading applications:", error);
    }
  }
  const code_outlook = async () => {
    try {
      const response = await fetch(`${apiUrl}ai/code_outlook/${post.id}/`);
      const result = await response.json();
      console.log("code : ", result.user_code);
      setCode(result.user_code);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  function openAuthPopup() {
    const authUrl =
      "https://login.microsoftonline.com/common/oauth2/deviceauth";
    const width = window.screen.width / 3;
    const height = window.screen.height;
    const left = window.screen.width - width;
    const top = 0;

    window.open(
      authUrl,
      "authPopup",
      `width=${width},height=${height},top=${top},left=${left}`
    );
  }

  const handleStartGmailScraping = () => {
    setIsProcessing(true);
    setShowGmailAuth(true);
  };

  const handleAuthComplete = (sessionId, result) => {
    console.log("Gmail processing completed:", result);
    setIsProcessing(false);
    setShowGmailAuth(false);
    Load_applications_imported();
    // Handle any post-processing here
  };

  const handleCopy = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(code)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
        })
        .catch(() => {
          setSnackbarOpen(true);
        });
    } else {
      setSnackbarOpen(true);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          <AlertTitle>{t("error")}</AlertTitle>
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        p: { xs: 1, sm: 2, md: 3 },
        backgroundColor: "#F4F5F7",
        minHeight: "100vh",
      }}
    >
      {/* Post Title and Action Buttons */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          mb: 0,
          gap: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            mb: -1,
            flexWrap: "wrap",
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          {/* Left section: back button + title */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 1,
              flexWrap: "wrap",
            }}
          >
            <IconButton
              onClick={() => navigate("/talent/post/PostDetails")}
              sx={{
                backgroundColor: "white",
                color: `${colors.primary}`,
                border: `1px solid ${colors.primary}`,
                borderRadius: "30%",
                "&:hover": { backgroundColor: "white" },
                width: { xs: 30, sm: 38 },
                height: { xs: 30, sm: 38 },
              }}
              title={t("go_back")}
            >
              <ArrowBackIosNewIcon />
            </IconButton>

            <Typography
              variant="h4"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 600,
                fontSize: { xs: "1.5rem", sm: "1.75rem", md: "2.125rem" },
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              {post?.title || "Post Title"}
            </Typography>
          </Box>

          {/* Right section: switch */}
          <Box

            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 1,
              mt: { xs: 2, sm: 0 },
            }}
          >
            {/*
    <FormControlLabel
      control={
        <Switch
          checked={displayMode === "board"}
          onChange={handleToggleView}
          color="primary"
        />
      }
      label={
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontSize: { xs: "0.875rem", sm: "1rem" },
          }}
        >
          {displayMode === "table"
            ? t("postDetails.candidates")
            : t("postDetails.stepsBoard")}
        </Typography>
      }
      labelPlacement="start"
      sx={{
        margin: 0,
        "& .MuiFormControlLabel-label": { marginLeft: 1 },
      }}
    />
  </Box> */}

            <Tooltip
              title={t("visualize_post")}
              placement="bottom"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: colors.primary,
                    color: 'white',
                    fontSize: '0.75rem',
                    fontFamily: 'Poppins',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    '& .MuiTooltip-arrow': {
                      color: colors.primary,
                    },
                  },
                },
              }}
            >
              <IconButton
                onClick={handleViewPost}
                sx={{
                  backgroundColor: "white",
                  color: `${colors.primary}`,
                  border: `1px solid ${colors.primary}`,
                  borderRadius: "30%",
                  "&:hover": {
                    backgroundColor: colors.primary,
                    color: "white",
                    transform: "scale(1.05)",
                    "& svg": {
                      color: "white",
                    },
                  },
                  transition: "all 0.3s ease",
                  width: { xs: 28, sm: 36 },
                  height: { xs: 28, sm: 36 },
                }}
              >
                <VisibilityIcon sx={{ fontSize: { xs: 10, sm: 15 }, transition: 'color 0.3s ease' }} />
              </IconButton>
            </Tooltip>
            <Tooltip
              title={t("edit_post")}
              placement="bottom"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: colors.primary,
                    color: 'white',
                    fontSize: '0.75rem',
                    fontFamily: 'Poppins',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    '& .MuiTooltip-arrow': {
                      color: colors.primary,
                    },
                  },
                },
              }}
            >
              <IconButton
                onClick={handleEditPost}
                sx={{
                  backgroundColor: "white",
                  color: `${colors.primary}`,
                  border: `1px solid ${colors.primary}`,
                  borderRadius: "30%",
                  "&:hover": {
                    backgroundColor: "#2563eb",
                    "& svg": {
                      color: "white",
                    },
                  },
                  width: { xs: 28, sm: 36 },
                  height: { xs: 28, sm: 36 },
                }}
                title={t("editPost")}
              >
                <EditIcon sx={{ fontSize: { xs: 10, sm: 15 }, transition: 'color 0.3s ease' }} />
              </IconButton>
            </Tooltip>
            <Tooltip
              title={t("share")}
              placement="bottom"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: colors.primary,
                    color: 'white',
                    fontSize: '0.75rem',
                    fontFamily: 'Poppins',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    '& .MuiTooltip-arrow': {
                      color: colors.primary,
                    },
                  },
                },
              }}
            >
              <IconButton
                onClick={handleSharePost}
                sx={{
                  backgroundColor: "white",
                  color: `${colors.primary}`,
                  border: `1px solid ${colors.primary}`,
                  borderRadius: "30%",
                  "&:hover": {
                    backgroundColor: "#2563eb",
                    "& svg": {
                      color: "white",
                    },
                  },
                  width: { xs: 28, sm: 36 },
                  height: { xs: 28, sm: 36 },
                }}
                title={t("share")}
              >
                <ShareIcon sx={{ transition: 'color 0.3s ease' }} />
              </IconButton></Tooltip>
            <Tooltip
              title={t("upload_resume")}
              placement="bottom"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: colors.primary,
                    color: 'white',
                    fontSize: '0.75rem',
                    fontFamily: 'Poppins',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    '& .MuiTooltip-arrow': {
                      color: colors.primary,
                    },
                  },
                },
              }}
            >

              <IconButton
                onClick={handleImportResumes}
                sx={{
                  backgroundColor: "white",
                  color: `${colors.primary}`,
                  border: `1px solid ${colors.primary}`,
                  borderRadius: "30%",
                  "&:hover": {
                    backgroundColor: "#2563eb",
                    "& svg": {
                      color: "white",
                    },
                  },
                  width: { xs: 28, sm: 36 },
                  height: { xs: 28, sm: 36 },
                }}
                title={t("postDetails.importResumes")}
              >
                <UploadFileIcon sx={{ fontSize: { xs: 10, sm: 15 }, transition: 'color 0.3s ease' }} />
              </IconButton>
            </Tooltip>
            {post.reference && (
              <>
                <Tooltip
                  title={t("scrap_mail")}
                  placement="bottom"
                  arrow
                  componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: colors.primary,
                        color: 'white',
                        fontSize: '0.75rem',
                        fontFamily: 'Poppins',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        '& .MuiTooltip-arrow': {
                          color: colors.primary,
                        },
                      },
                    },
                  }}
                >
                  {post.accountType === "m" ? (
                    <IconButton
                      sx={{
                        backgroundColor: "white",
                        color: `${colors.primary}`,
                        border: `1px solid ${colors.primary}`,
                        borderRadius: "30%",
                        "&:hover": {
                          backgroundColor: "#2563eb",
                          "& svg": {
                            color: "white",
                          },
                        },
                        width: { xs: 30, sm: 38 },
                        height: { xs: 30, sm: 38 },
                      }}
                      onClick={() => {
                        statechange(true);
                        Scrapping();
                      }}
                      disabled={isProcessingOutlook}
                      onMouseUp={() => {
                        setTimeout(() => {
                          code_outlook();
                          setIsScrappingLaunched(true);
                        }, 2000);
                        setTimeout(() => {
                          openAuthPopup();
                        }, 5000);
                      }}
                    // startIcon={<AutoModeIcon />}
                    >
                      <AutoModeIcon sx={{ fontSize: { xs: 10, sm: 15 }, transition: 'color 0.3s ease' }} />
                      {/* {isProcessingOutlook ? "Processing Outlook..." : "Outlook Scraping"} */}
                    </IconButton>
                  ) : (
                    <IconButton
                      sx={{
                        backgroundColor: "white",
                        color: `${colors.primary}`,
                        border: `1px solid ${colors.primary}`,
                        borderRadius: "30%",
                        "&:hover": {
                          backgroundColor: "#2563eb",
                          "& svg": {
                            color: "white",
                          },
                        },
                        width: { xs: 28, sm: 36 },
                        height: { xs: 28, sm: 36 },
                      }}
                      // startIcon={<AutoModeIcon />}
                      onClick={handleStartGmailScraping}
                      disabled={isProcessing}
                    >
                      <AutoModeIcon sx={{ fontSize: { xs: 10, sm: 15 }, transition: 'color 0.3s ease' }} />
                      {/* {isProcessing ? "Processing Gmail..." : "Gmail Scraping"} */}
                    </IconButton>
                  )}</Tooltip>
              </>
            )}
            {showGmailAuth && (
              <GmailAuth
                onAuthComplete={handleAuthComplete}
                postId={post.id} // Pass the current post ID
                sourceCall="post"
                sujet=""
              />
            )}
            {isScrappingLaunched ? (
              <>
                <StyledButton>{code}</StyledButton>
                <Tooltip title={copied ? "Copied!" : "Copy code"}>
                  <IconButton onClick={handleCopy} size="small" sx={{ ml: 2 }}>
                    {copied ? (
                      <CheckCircleIcon color="success" />
                    ) : (
                      <ContentCopyIcon />
                    )}
                  </IconButton>
                </Tooltip>{" "}
              </>
            ) : (
              <></>
            )}
          </Box>
        </Box>

        {/* Buttons - responsive layout */}
        <Box
          sx={{
            display: "flex",
            gap: 1,
            ml: { xs: "auto", sm: "10%" },
            justifyContent: { xs: "center", sm: "flex-start" },
            flexWrap: "wrap",
            mb: 2,
            "& > *": {
              minWidth: { xs: 28, sm: 36 },
            },
          }}
        ></Box>
      </Box>

      {/* View Toggle Switch - responsive alignment */}

      {/* Candidates Display */}
      {applications ? (
        displayMode === "table" ? (
          <Box
            sx={{
              px: { xs: 0, sm: 1 },
              width: "100%",
            }}
          >
            <DataTable
              candidates={applications}
              knob={true}
              steps={steps}
              post_id={post?.id}
              onCandidatesUpdate={refreshApplications}
              filterOptions={filterOptions}
              setFilterOptions={setFilterOptions}
              onFilterApply={() => {
                refreshApplications();
              }}
              postQuiz={post?.quiz}
            />
          </Box>
        ) : (
          <Box
            sx={{
              px: { xs: 0, sm: 1 },
              width: "100%",
              overflowX: "auto",
            }}
          >
            <ControlledBoard
              candidates={applications}
              onUpdateStep={updateApplicationStep}
              deleteSteps={deleteSteps}
              setSteps={setSteps}
              setStepId={() => { }}
              createStep={createStep}
              steps={steps}
              post={post}
            />
          </Box>
        )
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
          <Typography sx={{ fontFamily: "Poppins", textAlign: "center" }}>
            {t("postDetails.error.voidCandidate")}
          </Typography>
        </Box>
      )}

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <SnackbarAlert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </SnackbarAlert>
      </Snackbar>

      {/* Import Resumes Dialog */}
      <ImportResumes
        open={importDialogOpen}
        onClose={() => setImportDialogOpen(false)}
        postID={post?.id}
        onImportSuccess={handleImportSuccess}
      />

      {/* QR Code Dialog for sharing */}
      <QRCodeDialog
        open={showQRCodeDialog}
        onClose={handleCloseQRCodeDialog}
        qrCodeUrl={qrCodeUrl}
        formData={post}
        callerComponent="NewPostDetails"
      />

      {/* Edit Dialogs */}
      <EditPostDetailsDialog
        setOpen={setEditDialogOpen}
        postTitle={postTitle}
        setPostTitle={setPostTitle}
        postDescription={postDescription}
        setPostDescription={setPostDescription}
        offerType={offerType}
        setOfferType={setOfferType}
        postRequirement={postRequirement}
        setPostRequirement={setPostRequirement}
        postDeadline={postDeadline}
        handleDateChange={handleDateChange}
        handleNext={handleNext}
        open={editDialogOpen}
        errors={errors}
        dateError={dateError}
        setDateError={setDateError}
        showRef={post?.scraped}
        accountType={accountType}
        setAccountType={setAccountType}
        reference={reference}
        setReference={setReference}
        recruiterEmail={recruiterEmail}
        setRecruiterEmail={setRecruiterEmail}
        setErrors={setErrors}
      />

      <EditWorkingDetailsDialog
        setOpen2={setEditWorkingDialogOpen}
        setOpen={setEditDialogOpen}
        open2={editWorkingDialogOpen}
        errors={errors}
        // Add the missing handlers and state variables
        handleImageUpload={handleImageUpload}
        setWorkingMode={setWorkingMode}
        workingMode={workingMode}
        location={locationValue}
        setLocation={setLocationValue}
        setErrors={setErrors}
        numPeople={numPeople}
        setNumPeople={setNumPeople}
        salary={salary}
        handleSalaryChange={handleSalaryChange}
        setSalary={setSalary}
        currency={currency}
        setCurrency={setCurrency}
        isChecked={isChecked}
        handleCheckboxChange={handleCheckboxChange}
        setIsChecked={setIsChecked}
        isCheckedScr={isCheckedScr}
        handleCheckboxChangeScr={handleCheckboxChangeScr}
        setIsCheckedScr={setIsCheckedScr}
        handleSave={handleSave}
        experience={experience}
        setExperience={setExperience}
        diploma={diploma}
        setDiploma={setDiploma}
        otherDiploma={otherDiploma}
        setOtherDiploma={setOtherDiploma}
        fieldOfStudy={fieldOfStudy}
        setFieldOfStudy={setFieldOfStudy}
        otherFieldOfStudy={otherFieldOfStudy}
        setOtherFieldOfStudy={setOtherFieldOfStudy}
        job={post}
        postTitle={postTitle}
      />
    </Box>
  );
};

export default NewPostDetails;
